import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=6a544b28&scoped=true&"
import script from "./Cancel.vue?vue&type=script&lang=js&"
export * from "./Cancel.vue?vue&type=script&lang=js&"
import style0 from "./Cancel.vue?vue&type=style&index=0&id=6a544b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a544b28",
  null
  
)

export default component.exports